
var artisansFolders = {
    getArtisanFolderPieces: function(uuidFolder)
    {
        $.ajax({
            type: 'GET',
            url: 'api/artisan/publicites/getFolder/' + uuidFolder,
            dataType: 'json',
        }).done(function(response) {
            if (response.success) {
                var lignes = response.msg;
                var html = '';

                lignes.forEach(function(ligne) {
                    var img = '';
                    switch (+ligne.status) {
                        case 0:
                            img = '<img src="assets/img/clust/pastilles/gris.svg" alt="Document manquant" title="Document manquant" width="12">'
                                + ' Manquant';
                            break;
                        case 1:
                            img = '<img src="assets/img/clust/pastilles/orange.svg" alt="Document chargé. En cours d\'étude" title="Document chargé. En cours d\'étude" width="12">'
                                + ' Document chargé. En cours d\'étude';
                            break;
                        case 2:
                            img = '<img src="assets/img/clust/pastilles/rouge.svg" alt="Document rejeté" title="Document rejeté" width="12">'
                                + ' Document rejeté';
                            break;
                        case 3:
                            img = '<img src="assets/img/clust/pastilles/vert.svg" alt="Document validé" title="Document validé" width="12">'
                                + ' Document validé';
                            break;
                    }

                    var form = '';
                    if (ligne.status < FoldersDocuments.STATUS.VALIDATE && ligne.readOnly !== true) {
                        form =
                            '<form class="form-fileupload">' +
                            '<input type="hidden" name="idFolderDocument" value="' + ligne.idFolderDocument + '">' +
                            '<span class="btn btn-light--darker fileinput-button">' +
                                '<i class="fal fa-file-plus"></i>' +
                            '<span>Ajouter un fichier ...</span>' +
                                '<input type="file" name="files[]" multiple' +
                                //'data-form-data="{\'idFolderDocument\': ' + ligne.idFolderDocument + '}"' +
                                'data-id="' + ligne.idFolderDocument + '">' +
                            '</span>' +
                            '</form>';

                        $('#modal-folder-documents-title').removeClass('d-none');
                    } else {
                        $('#modal-folder-documents-title').addClass('d-none');
                    }

                    var htmlName = ligne.name ? '<li>' + ligne.name + '</li>' : '';

                    html +=
                        '<div class="row">' +
                        '<div class="col-3">' +
                        '<h4 class="mt-0">' + ligne.libelle + '</h4>' +
                        '<ul>' +
                        '<a href="api/folder/downloadDocument/' + ligne.uuid + '" download>' + htmlName + '</a>' +
                        '</ul>' +
                        '</div>' +
                        '<div class="col-3">' + img + '</div>' +
                        '<div class="col-3"><p class="text-danger">' + ligne.comment + '</p></div>' +
                        '<div class="col-3">' + form + '</div>' +
                        '</div>'
                    ;
                });

                $('#modal-folder-documents').html(html);

                var $progress    = $('#progress');
                var $progressBar = $('#progress .progress-bar');

                $('.form-fileupload').fileupload({
                    url: '/api/artisan/publicites/upload/' + uuidFolder,
                    dataType: 'json',
                    add: function (e, data) {
                        $progress.removeClass('d-none');
                        data.submit();
                    },
                    progressall: function (e, data) {
                        $progressBar.css(
                            'width',
                            parseInt(data.loaded / data.total * 100, 10) + '%'
                        );
                    },
                    done: function (e, data) {
                        $progress.addClass('d-none');
                        if (data.result.success) {
                            artisansFolders.getArtisanFolderPieces(uuidFolder);
                        } else {
                            displayErrorMessage(data.result.msg);
                        }
                    },
                });
            } else {
                displayErrorMessage(response.msg);
            }
        });
    }
};
